import { useAppQuery } from "./useAppQuery.js";

interface UseUndoActionsCountQueryOptions {
    onSuccess?: (data: { actionIds: string[] }) => void;
    onError?: (error: any) => void;
    enabled?: boolean;
}

export const useUndoActionsCountQuery = (options: UseUndoActionsCountQueryOptions) => {
    return useAppQuery<{ actionIds: string[] }, Error>({
        url: "/api/actions/undo/count",
        reactQueryOptions: { ...options },
        initialData: { actionIds: [] }
    });
};
